import { render, staticRenderFns } from "./getpasswordlocker.vue?vue&type=template&id=56ac0aee&scoped=true"
import script from "./getpasswordlocker.vue?vue&type=script&lang=js"
export * from "./getpasswordlocker.vue?vue&type=script&lang=js"
import style0 from "./getpasswordlocker.vue?vue&type=style&index=0&id=56ac0aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac0aee",
  null
  
)

export default component.exports